<div class="flex justify-between items-center mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Notificar fornecedores — {{ comprasOsIds.length }} OS selecionada(s)
  </div>
</div>

@if (!sent) {
  <div class="mb-4 flex flex-col gap-2">
    <mat-checkbox [(ngModel)]="enviarEmail" [disabled]="sending"
      >Enviar e-mail ao fornecedor</mat-checkbox
    >
    <mat-checkbox [(ngModel)]="gerarLinkWhatsApp" [disabled]="sending"
      >Gerar link WhatsApp</mat-checkbox
    >
  </div>

  <div class="flex justify-end items-center gap-2">
    <button
      mat-flat-button
      class="btn-tg-white"
      (click)="close()"
      [disabled]="sending"
    >
      Cancelar
    </button>
    <button
      mat-flat-button
      class="btn-tg"
      (click)="notificar()"
      [disabled]="sending"
    >
      @if (sending) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Enviar
      }
    </button>
  </div>
} @else {
  @if (enviarEmail) {
    <div class="mb-3 text-gray-700">
      {{ emailsEnviados }} e-mail(s) enviado(s).
    </div>
  }

  @if (linksWhatsApp.length > 0) {
    <div class="mb-4 flex flex-col gap-3">
      @for (linkItem of linksWhatsApp; track linkItem.link) {
        <div
          class="border border-gray-300 rounded-lg p-3 flex justify-between items-center gap-3"
        >
          <div>
            <div class="font-bold text-gray-700">
              {{ linkItem.nomeFornecedor }}
            </div>
            <div class="text-sm text-gray-500">
              {{ linkItem.codigosOs.join(', ') }}
            </div>
          </div>
          <div class="flex gap-2">
            <button
              mat-flat-button
              class="btn-tg-white"
              (click)="copyLink(linkItem.link)"
            >
              Copiar link
            </button>
            <button
              mat-flat-button
              class="btn-tg"
              (click)="openLink(linkItem.link)"
            >
              Abrir WhatsApp
            </button>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="mb-4 text-gray-500">
      Nenhum link WhatsApp gerado (verifique se as OSs possuem fornecedor
      atribuído).
    </div>
  }

  <div class="flex justify-end">
    <button mat-flat-button class="btn-tg" (click)="close()">Fechar</button>
  </div>
}
